import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

//防止重复跳转路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [{
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/components/Home/Home.vue'], resolve),
    },
    {
      path: '/txw',
      name: 'txw',
      component: resolve => require(['@/components/Txw/Txw.vue'], resolve),
    },
    {
      path: '/txlive',
      name: 'txlive',
      component: resolve => require(['@/components/Txlive/Txlive.vue'], resolve),
    },
    {
      path: '/dtqp',
      name: 'dtqp',
      component: resolve => require(['@/components/Dtqp/Dtqp.vue'], resolve),
    },
    {
      path: '/dtfish',
      name: 'dtfish',
      component: resolve => require(['@/components/Dtfish/Dtfish.vue'], resolve),
    },
    {
      path: '/exhibition',
      component: resolve => require(['@/components/Exhibition/Exhibition.vue'], resolve),
      children: [{
          path: '/',
          /* redirect: 'twentyPage' */
          redirect: 'starBlessing'
        },
       /*  {
          path: 'twentyPage',
          name: 'twentyPage',
          component: resolve => require(['@/components/Exhibition/components/twentyPage.vue'], resolve),
        }, */ //2020page
        {
          path: 'starBlessing',
          name: 'starBlessing',
          component: resolve => require(['@/components/Exhibition/components/starBlessing.vue'], resolve),
        }, //明星祝福
        {
          path: 'pageVideo',
          name: 'pageVideo',
          component: resolve => require(['@/components/Exhibition/components/pageVideo.vue'], resolve),
        }, //2019page精彩视频
        {
          path: 'pagePicture',
          name: 'pagePicture',
          component: resolve => require(['@/components/Exhibition/components/pagePicture.vue'], resolve),
        }, //2019page现场照片
        {
          path: 'pageIntroduce',
          name: 'pageIntroduce',
          component: resolve => require(['@/components/Exhibition/components/pageIntroduce.vue'], resolve),
        }, //2019page展会介绍
        {
          path: 'geVideo',
          name: 'geVideo',
          component: resolve => require(['@/components/Exhibition/components/geVideo.vue'], resolve),
        }, //2019g2e精彩视频
        {
          path: 'gePicture',
          name: 'gePicture',
          component: resolve => require(['@/components/Exhibition/components/gePicture.vue'], resolve),
        }, //2019g2e现场照片
        {
          path: 'geIntroduce',
          name: 'geIntroduce',
          component: resolve => require(['@/components/Exhibition/components/geIntroduce.vue'], resolve),
        }, //2019g2e展会介绍
      ]
    }
    // {
    //   path: '/tryGame',
    //   component: resolve => require(['@/components/tryGame/tryGame.vue'], resolve),
    //   children: [{
    //       path: '/',
    //       redirect: 'ysz'
    //     },
    //     {
    //       path: 'ysz',
    //       name: 'ysz',
    //       component: resolve => require(['@/components/tryGame/components/ysz.vue'], resolve),
    //     }, //演示站
    //     {
    //       path: 'chess',
    //       name: 'chess',
    //       component: resolve => require(['@/components/tryGame/components/chess.vue'], resolve),
    //     }, //大唐棋牌
    //     {
    //       path: 'fish',
    //       name: 'fish',
    //       component: resolve => require(['@/components/tryGame/components/fish.vue'], resolve),
    //     }, //大唐捕鱼
    //     {
    //       path: 'live',
    //       name: 'live',
    //       component: resolve => require(['@/components/tryGame/components/live.vue'], resolve),
    //     }, //天下汇视讯
    //   ]
    // },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js